import React from "react";

const TotalRecords = ({ totalRecords }) => {
  return (
    <>
      {totalRecords > 0 ? (
        <div className="col-md-2 text-end">
          <span className="fw-bold fs-6">Total Records: </span>
          <span className="fs-6">{totalRecords}</span>
        </div>
      ) : (
        <></>
      )}
    </>
  );
};

export default TotalRecords;
